import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";
import { OptionType } from "./ISBNSReducer";
import { SegItem } from "./Segreducer";
import { stat } from "fs";

export interface segDetailsInterface {
  FULL_TITLE: string;
  AUTHOR_1: string;
  PUB_DATE: string;
  TESTIMPRINTFROMHNA: string;
  RELEASE_DATE: string;
  EAN: string;
  GROUP_1: string;
  FORMAT: string;
  COMPETITIVE_TITLES?: string;
  FULL_TITLES?: [];
  PRINT_RUN?: number | string;
  US_PRICE?: number;
  ANNOUNCED_1ST_PRINTING__BEST?: number | string;
  PAGES?: number;
  TRIMWIDTH?: string;
  TRIMLENGTH?: string;
  totlaEst: number;
  _id: string;
  SEASON: string;
  PAPER_CUT_OFF:string;
  LDC?: string;
}
interface CompInit {
  $numberDecimal: string;
}

interface Accounts {
  accountName: any;
  accountNumber: any;
  compInit?: string | null;
  Cpos_LTD?: string | null;
  compGross?: string | null;
  compNet?: string | null;
  cpos4wkPOS?: string | null;
  cpos8wkPOS?: string | null;
  currEst?: string | null;
  printmtdDate?: string | null;
  retPercentage?: string | null;
  pub_goal?: string | null;
  suppEst?: string | null;
  sales_notes?: string;
  [key: string]: any;

}

interface Organization {
  _id: any;
  accounts: Accounts[],
  orgName: any;
  organizationId: string | null;
}
const emptySegDetails: segDetailsInterface = {
  FULL_TITLE: "",
  AUTHOR_1: "",
  PUB_DATE: "",
  TESTIMPRINTFROMHNA: "",
  RELEASE_DATE: "",
  EAN: "",
  GROUP_1: "",
  FORMAT: "",
  COMPETITIVE_TITLES: "",
  FULL_TITLES: [],
  PRINT_RUN: "",
  US_PRICE: 0,
  ANNOUNCED_1ST_PRINTING__BEST: "",
  PAGES: 0,
  TRIMWIDTH: "",
  TRIMLENGTH: "",
  totlaEst: 0,
  _id: "",
  SEASON: "",
  PAPER_CUT_OFF:"",
  LDC: ""
};

export interface otisRecordInterface {
  newRow: any;
  [key: string]: any; // Add index signature
  account_id: string | null;
  account_name: string | null;
  sales_notes: string | null;
  account_number: string | null;
  pubGoal: string | null;
  mtgPrint: string | null;
  currEst: any | null;
  initOrd: string | null;
  suppEst: string | null;
  compInit: string | null;
  compGross: string | null;
  compNet: string | null;
  retPercentage: string | null;
  Cpos_4wk: string | null;
  Cpos_8wk: string | null;
  Cpos_LTD: string | null;
  TestRow: any;
  DISTRIBUTION_CHANNEL: any;
  DISTRIBUTION_CHANNEL_NAME: any;
  organizations: Organization[];
  _id: any;
  isNew: any;
  main_pubgoal: string | null; // Add this
  main_current_estimate: string | null; // Add this
}

export interface clearOtisRecordInterface {
  account_id: string | null,
  sales_notes: string | null;
  account_number: string | null;
  pubGoal: string | null;
  mtgPrint: string | null;
  currEst: any | null;
  suppEst: string | null;
  compInit: string | null;
  compGross: string | null;
  compNet: string | null;
  retPercentage: string | null;
  Cpos_4wk: string | null;
  Cpos_8wk: string | null;
  Cpos_LTD: string | null;
}


interface UpdateTableDataPayload {
  rowIndex: number;
  cellName: keyof otisRecordInterface;
  value: any;
}
interface OTISDataInterface {
  _id: string;
  SEGTitle: string;
  SEGINVNotes: string;
  SEGOTISRecords: otisRecordInterface[];
  finalData: otisRecordInterface[];
  segDetails: segDetailsInterface;
  eanSelectedValue: OptionType | null;
  eanNumberValue: OptionType | null;
  selectedOtisSummary: SegItem;
  inputEmpty: boolean;
  SEASON: any
}



interface OTISState {
  data: OTISDataInterface;
  status: string;
  statusCode: number;
  error: string | null;
  selectedSeg: string;
  startingRows: number;
  totalPubGoal: number;
  totalCurrEst: number;
  updateOtis: {
    status: number;
    error: string;
    message: string;
    isLoading: boolean;
  };
  submitButtonDisabled: boolean;
  TestRow: [],
  UpdateTableCondition: boolean,
  saveRowHandle: boolean,
  scrollBottm: boolean,
  isvalueClear: boolean,
  isDisablePopup: number,
  saveAllData: boolean,
  localClear: boolean,
  inputClear: any,
  inputtedData: boolean,
  inputtedDataSt: boolean,

  closeExpand: boolean,
  SaveButtonClear: boolean,
  pubstart: boolean;
  selectedDistribution: string | null;
  selectedOrganization: string | null;
  selectedAccountName: string | null;
  repCodeSearchOptions: [];
  accountSearchOptions: [];
  organizationSearchOptions: [];
  hasMore: boolean;
  searchTerm: any; currentPage: number,
  debouncedSearchTerm: any,
  shouldClear: boolean
  addrowcancelData: boolean;
  LoadingTest: boolean,
  isScroll: boolean,
  noSegId: boolean,
  local: boolean,
  renderSeason: boolean,
  resetSeason: boolean,
  isClear: boolean,
  ClearCompState:boolean;
  FetchOtisLoading:boolean;

}

const OTISInitialObject: otisRecordInterface = {
  account_id: null,
  account_name: null,
  sales_notes: null,
  account_number: null,
  pubGoal: null,
  mtgPrint: null,
  currEst: null,
  initOrd: null,
  suppEst: null,
  compInit: null,
  compGross: null,
  compNet: null,
  retPercentage: null,
  Cpos_4wk: null,
  Cpos_8wk: null,
  Cpos_LTD: null,
  TestRow: [],
  organizations: [],
  _id: null,
  isNew: "",
  DISTRIBUTION_CHANNEL: null,
  DISTRIBUTION_CHANNEL_NAME: null,
  newRow: undefined,
  main_pubgoal: null,
  main_current_estimate: null
};





const initialState: OTISState = {
  data: {
    SEASON: "",
    inputEmpty: false,
    _id: "",
    SEGOTISRecords: [],
    finalData: [],
    segDetails: {
      PUB_DATE: "",
      TESTIMPRINTFROMHNA: "",
      RELEASE_DATE: "",
      FULL_TITLE: "",
      AUTHOR_1: "",
      EAN: "",
      GROUP_1: "",
      FORMAT: "",
      PAPER_CUT_OFF: "",
      LDC: "",
      totlaEst: 0,
      _id: "",
      SEASON: ''
    },
    SEGTitle: "",
    SEGINVNotes: "",
    eanSelectedValue: null,
    eanNumberValue: null,
    selectedOtisSummary: {
      _id: "",
      LTD_GROSS_UNITS: "",
      EAN: 0,
      SEASON: "",
      GROUP_1: "",
      TESTIMPRINTFROMHNA: "",
      FULL_TITLE: "",
      AUTHOR_1: "",
      PUB_DATE: "",
      RELEASE_DATE: "",
      FORMAT: "",
      US_PRICE: 0,
      bksnPos: ""
    }
  },
  startingRows: 5,
  status: "",
  error: null,
  statusCode: 0,
  selectedSeg: "",
  updateOtis: {
    error: "",
    message: "",
    status: 0,
    isLoading: false,
  },
  totalPubGoal: 0,
  submitButtonDisabled: true,
  TestRow: [],
  UpdateTableCondition: false,
  saveRowHandle: false,
  scrollBottm: false,
  isvalueClear: false,
  isDisablePopup: 1,
  saveAllData: false,
  localClear: false,
  inputClear: 0,
  inputtedData: false,
  inputtedDataSt: false,
  closeExpand: false,
  SaveButtonClear: false,
  pubstart: false,
  selectedDistribution: null,
  selectedOrganization: null,
  selectedAccountName: null,
  repCodeSearchOptions: [],
  accountSearchOptions: [],
  organizationSearchOptions: [],
  hasMore: false,
  searchTerm: "",
  currentPage: 1,
  debouncedSearchTerm: "",
  shouldClear: false,
  addrowcancelData: false,
  totalCurrEst: 0,
  isScroll: false,
  noSegId: false,
  local: true,
  renderSeason: true,
  resetSeason: true,
  isClear: false,
  LoadingTest: false,
  ClearCompState:false,
  FetchOtisLoading:false
};

export const FetchOTISRecord = createAsyncThunk(
  "FetchOTISRecord",
  async (data: any, { rejectWithValue }) => {
    console.log("datato update", data)
    try {
      const url = API.FETCHOTISRECORD;
      const response = await axios.post(url, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const updateSelectedOTISRecord = createAsyncThunk(
  "updateOTISRecord",
  async (data: any, { rejectWithValue }) => {
    try {
      const url = API.UPDATEOTISRECORD;

      // Normalize any decimal input (string | object | missing)
      const normalizeDecimal = (val: any) => {
        if (val == null || val === "") {
          return { $numberDecimal: "" };
        }
        if (typeof val === "string") {
          return { $numberDecimal: val.trim() || "" };
        }
        if (typeof val === "object" && val.$numberDecimal !== undefined) {
          return {
            $numberDecimal: val.$numberDecimal?.trim() || "",
          };
        }
        return { $numberDecimal: "" };
      };

      const transformResultRows = (rows: any[]) =>
        (rows || []).map((record: any) => ({
          ...record,
          organizations: (record.organizations || []).map((org: any) => ({
            ...org,
            accounts: (org.accounts || []).map((account: any) => ({
              ...account,
              pub_goal: normalizeDecimal(account.pub_goal),
              currEst: normalizeDecimal(account.currEst),
              suppEst: normalizeDecimal(account.suppEst),
              compInit: account.compInit,
              compGross: account.compGross,
              compNet: account.compNet,
              retPercentage: normalizeDecimal(account.retPercentage),
              printmtdDate: normalizeDecimal(account.printmtdDate),
              cpos4wkPOS: normalizeDecimal(account.cpos4wkPOS),
              cpos8wkPOS: normalizeDecimal(account.cpos8wkPOS),
              Cpos_LTD: normalizeDecimal(account.Cpos_LTD),
              sales_notes: account.sales_notes || "",
            })),
          })),
        }));

      const scope = data.updateScope || "full";

      let payload: Record<string, unknown>;

      if (scope === "segINVNotesOnly") {
        payload = {
          _id: data._id,
          updateScope: "segINVNotesOnly",
          segINVNotes: data.segINVNotes,
        };
      } else if (scope === "metadataOnly") {
        payload = {
          _id: data._id,
          updateScope: "metadataOnly",
          Title: data.Title,
          segINVNotes: data.segINVNotes,
          eanSelectedValue: data.eanSelectedValue,
        };
      } else {
        payload = {
          _id: data._id,
          updateScope: scope,
          Title: data.Title,
          segINVNotes: data.segINVNotes,
          eanSelectedValue: data.eanSelectedValue,
          result: transformResultRows(data.result || []),
        };
      }

      const response = await axios.post(url, payload);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const fetchSelectedSegSummary = createAsyncThunk(
  "fetchSelectedSummary",
  async (data: any, { rejectWithValue }) => {
    try {
      const url = API.fetchSelectedSegSummary
      const response = await axios.post(url, data)
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/**
 * fetchOTISRecord builds options from seg: title label uses FULL_TITLE, ISBN uses EAN.
 * FULL_TITLE can be empty in Mongo while EAN is present — the Title Select clears but ISBN stays.
 * Raw ObjectId strings from dc_otis also break the Title control; keep the prior client option when
 * the server sends the same id with no usable label.
 */
function mergeCompDropdownOption(incoming: any, prev: OptionType | null): OptionType | null {
  if (incoming == null || incoming === "") return prev ?? null;
  if (typeof incoming === "string") return prev ?? null;
  if (typeof incoming === "object" && incoming !== null) {
    const incLabel = incoming.label != null ? String(incoming.label).trim() : "";
    const prevLabel = prev?.label != null ? String(prev.label).trim() : "";
    const sameId =
      prev != null &&
      incoming.value != null &&
      prev.value != null &&
      String(incoming.value) === String(prev.value);
    if (sameId && !incLabel && prevLabel) return prev;
        if (!sameId && prevLabel) return prev;
  }
  return (incoming as OptionType) ?? prev ?? null;
}

const Segslice = createSlice({
  name: "SegData",
  initialState,
  reducers: {
    updateSegOtisRecords: (state, action) => {
      state.data.SEGOTISRecords = action.payload;
    },
    clearSegDetails(state) {
      state.data.segDetails = { ...emptySegDetails };
    },
    setFinalData: (state, action) => {
      state.data.finalData = action.payload;
    },
    clearAllEditableFields(state) {
      const clearedData = state.data.SEGOTISRecords.map((record) => ({
        ...record,
        main_sales_notes: "",
        main_pubgoal: null,
        main_current_estimate: null,
        main_supplemental_estimate: null,
        main_print_meeting_date: null,
        organizations: record.organizations.map((org) => ({
          ...org,
          org_sales_notes: "",
          org_pub_goal: null,
          org_current_estimate: null,
          org_supplemental_estimate: null,
          accounts: org.accounts.map((account) => ({
            ...account,
            Cpos_LTD: null,
            compGross: null,
            compNet: null,
            compInit: null,
            cpos4wkPOS: null,
            cpos8wkPOS: null,
            currEst: null,
            printmtdDate: null,
            retPercentage: null,
            pub_goal: null,
            suppEst: null,
            sales_notes: "",
          })),
        })),
      }));

      state.data.SEGOTISRecords = clearedData;
      state.data.finalData = clearedData;
      state.totalPubGoal = 0;
      state.totalCurrEst = 0;
    },
    setSelectedSeg: (state, action) => {
      state.selectedSeg = action.payload;
    },
    removeNewRows: (state) => {
      if (state.data.SEGOTISRecords) {
        const index = state.data.SEGOTISRecords.findIndex(
          (record) => record.isNew
        );
        if (index !== -1) {
          state.data.SEGOTISRecords.splice(index, 1);
        }
      }
    },
    updateStartingRows: (state, action) => {
      state.startingRows = state.startingRows + action.payload;
    },
    updateTableData: (state, action: PayloadAction<UpdateTableDataPayload>) => {
      if (
        (action.payload.value?.length <= 0 ||
          isNaN(Number(action.payload.value))) &&
        action.payload.cellName !== "account_name" &&
        action.payload.cellName !== "account_id" &&
        action.payload.cellName !== "sales_notes"
      ) {
        if (isNaN(Number(action.payload.value))) {
          if (action.payload.value?.length < 1)
            state.data.SEGOTISRecords[action.payload.rowIndex][
              action.payload.cellName
            ] = null;
          else
            state.data.SEGOTISRecords[action.payload.rowIndex][
              action.payload.cellName
            ] = action.payload.value.slice(0, -1);
        } else
          state.data.SEGOTISRecords[action.payload.rowIndex][
            action.payload.cellName
          ] = null;
      } else if (
        Object.keys(action.payload.value).length <= 0 &&
        (action.payload.cellName === "account_name" ||
          action.payload.cellName === "account_id")
      ) {
        state.data.SEGOTISRecords[action.payload.rowIndex][
          action.payload.cellName
        ] = null;
      } else {
        state.data.SEGOTISRecords[action.payload.rowIndex][
          action.payload.cellName
        ] = action.payload.value;
      }
    },
    emptySelectedOTISData: (state) => {
      state.data = initialState.data;
      state.updateOtis = initialState.updateOtis;
    },
    emptyUpdatedOtisStatus: (state) => {
      state.updateOtis.status = initialState.updateOtis.status;
    },
    addRowInOTISRecords: (state) => {
      if (!state.data.SEGOTISRecords) {
        state.data.SEGOTISRecords = [];
      }
      console.log("Before Adding Row:", state.data.SEGOTISRecords);
      state.data.SEGOTISRecords.push({ ...OTISInitialObject, isNew: true });
      console.log("After Adding Row:", state.data.SEGOTISRecords);
    },
    handleSaveButtonClear: (state, action) => {
      state.SaveButtonClear = action.payload;
    },
    clearCompInitAction: (state) => {
      // Commented out logic remains unchanged
    },
    SetaddrowcancelData: (state, action) => {
      state.addrowcancelData = action.payload;
    },
    setPubStart: (state, action) => {
      state.pubstart = action.payload;
    },
    removeOTISRow: (state) => {
      state.data.SEGOTISRecords.pop();
    },
    updateSubmitBtn: (state, action) => {
      state.submitButtonDisabled = action.payload;
    },
    updateSegTitle: (state, action) => {
      console.log("action.payload", action.payload);
      state.data.SEGTitle = action.payload;
    },
    updateSegINVNotes: (state, action) => {
      state.data.SEGINVNotes = action.payload;
    },
    UpdateTestRow: (state, action) => {
      state.TestRow = action.payload;
    },
    updateEanSelectedValue: (state, action) => {
      state.data.eanSelectedValue = action.payload;
    },
    updateEanNumberValue: (state, action) => {
      state.data.eanNumberValue = action.payload;
    },
    UpdateSelectedTitleValue: (state, action) => {
      state.data.segDetails.FULL_TITLE = action.payload;
    },
    UpdateSelectedIsbnValue: (state, action) => {
      state.data.segDetails.EAN = action.payload;
      console.log("valueoncross in reducer", state.data.segDetails.EAN);
    },
    UpdateSeason: (state, action) => {
      state.data.segDetails.SEASON = action.payload;
    },
    UpdateSelectedIsbnId: (state, action) => {
      state.data.segDetails._id = action.payload;
    },
    emptysegDetails: (state) => {
      state.data.segDetails = initialState.data.segDetails;
    },
    emptySelectedOtisSummary: (state) => {
      state.data.selectedOtisSummary = initialState.data.selectedOtisSummary;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload;
    },
    emptyInputsTest: (state, action) => {
      state.data.inputEmpty = action.payload;
    },
    UpdatetableCond: (state, action) => {
      state.UpdateTableCondition = action.payload;
    },
    handleSaveToast: (state, action) => {
      state.saveRowHandle = action.payload;
    },
    scrollToBottom: (state, action) => {
      state.scrollBottm = action.payload;
    },
    SetvalueClear: (state, action) => {
      state.isvalueClear = action.payload;
    },
    SetDisablePopup: (state) => {
      state.isDisablePopup = 0;
    },
    setHandleSaveAll: (state, action) => {
      state.saveAllData = action.payload;
    },
    handleLocalClear: (state, action) => {
      state.localClear = action.payload;
    },
    handleInputClear: (state, action) => {
      state.inputClear = action.payload;
    },
    setInputtedData: (state, action) => {
      console.log("hasValidFormData updating inputtedData", action.payload);
      state.inputtedData = action.payload;
    },
    setInputtedDataSt: (state, action) => {
      state.inputtedDataSt = action.payload;
    },
    setCloseExpand: (state, action) => {
      state.closeExpand = action.payload;
    },
    setselectedDistribution: (state, action) => {
      state.selectedDistribution = action.payload;
    },
    setSelectedOrganization: (state, action) => {
      state.selectedOrganization = action.payload;
    },
    setSelectedAccountName: (state, action) => {
      state.selectedAccountName = action.payload;
    },
    setRepCodeSearchOptions: (state, action) => {
      state.repCodeSearchOptions = action.payload;
    },
    setAccountSearchOptions: (state, action) => {
      state.accountSearchOptions = action.payload;
    },
    setOrganizationSearchOptions: (state, action) => {
      state.organizationSearchOptions = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setDebouncedSearchTerm: (state, action) => {
      state.debouncedSearchTerm = action.payload;
    },
    setShouldClear: (state, action) => {
      console.log("should Clear called", action.payload);
      state.shouldClear = action.payload;
    },
    setIsScroll: (state, action) => {
      console.log("flag2121 is scroll called", action.payload);
      state.isScroll = action.payload;
    },
    setNoSegId: (state, action) => {
      console.log("is scroll called", action.payload);
      state.noSegId = action.payload;
    },
    setLocal: (state, action) => {
      console.log("is scroll called", action.payload);
      state.local = action.payload;
    },
    setRenderSeason: (state, action) => {
      state.renderSeason = action.payload;
    },
    setResetSeason: (state, action) => {
      state.resetSeason = action.payload;
    },
    setIsCleared: (state, action) => {
      state.isClear = action.payload;
    },
    //     setTextReducer: (state, action) => {
    //   state.isText = action.payload;
    // },
    // setShowText: (state,action) => {
    //   state.showText = action.payload;
    // },
    setClearCompState:(state,action)=>{
      state.ClearCompState=action.payload
    }

  },
  extraReducers(builder) {
    builder
      .addCase(FetchOTISRecord.pending, (state) => {
        state.status = "Loading";
        state.FetchOtisLoading=true;
      })
      .addCase(FetchOTISRecord.fulfilled, (state, action) => {
        state.status = "success";
        state.FetchOtisLoading = false;
        const incoming = action.payload.data;
        // fetchOTISRecord returns dc_otis + segDetails; eanSelectedValue / eanNumberValue are derived
        // from Mongo eanSelectedValue. The client sets them in Redux before the request finishes, but
        // the document often does not have eanSelectedValue yet — the API then sends null and a full
        // replace here cleared the comparable title a few seconds after selection.
        const prevEanSel = state.data.eanSelectedValue;
        const prevEanNum = state.data.eanNumberValue;
        const prevSummary = state.data.selectedOtisSummary;
        state.data = {
          ...state.data,
          ...incoming,
          eanSelectedValue: mergeCompDropdownOption(incoming.eanSelectedValue, prevEanSel),
          eanNumberValue: mergeCompDropdownOption(incoming.eanNumberValue, prevEanNum),
          selectedOtisSummary: incoming.selectedOtisSummary ?? prevSummary,
        };
        const tableData = state.data.SEGOTISRecords || [];
        console.log("table data in api call 2", tableData);
        console.log(action.payload.data, "dataaaaa");
      })
      .addCase(FetchOTISRecord.rejected, (state) => {
        state.status = "Failed";
        state.error = "Error";
        state.FetchOtisLoading=false

      });

    builder
      .addCase(updateSelectedOTISRecord.pending, (state) => {
        state.submitButtonDisabled = true;
        state.updateOtis.isLoading = true;
      })
      .addCase(updateSelectedOTISRecord.fulfilled, (state, action) => {
        state.updateOtis.isLoading = false;
        state.updateOtis.message = action.payload.data.message ?? "Success";
        state.updateOtis.status = action.payload.status;
      })
      .addCase(
        updateSelectedOTISRecord.rejected,
        (state, action: PayloadAction<any>) => {
          state.updateOtis.isLoading = false;
          state.status = action.payload.status;
        }
      );

    builder
      .addCase(fetchSelectedSegSummary.pending, (state) => {})
      .addCase(fetchSelectedSegSummary.fulfilled, (state, action) => {
        state.data.selectedOtisSummary = action.payload.data.selectedSeg;
        console.log(
          action.payload.data.selectedSeg,
          " action.payload.data.selectedSeg"
        );
        if (action.payload.data.ltdGrossUnits)
          state.data.selectedOtisSummary.LTD_GROSS_UNITS =
            action.payload.data.ltdGrossUnits;
        if (action.payload.data.bksnPos)
          state.data.selectedOtisSummary.bksnPos = action.payload.data.bksnPos;
      })
      .addCase(
        fetchSelectedSegSummary.rejected,
        (state, action: PayloadAction<any>) => {}
      );
  },
});

export const {
  updateSegINVNotes,
  updateEanSelectedValue,
  updateEanNumberValue,
  UpdateSelectedIsbnId,
  UpdateSelectedIsbnValue,
  UpdateSelectedTitleValue,
  updateSegTitle,
  updateSubmitBtn,
  addRowInOTISRecords,
  setSelectedSeg,
  updateTableData,
  emptySelectedOTISData,
  emptyUpdatedOtisStatus,
  removeOTISRow,
  emptySelectedOtisSummary,
  updateSegOtisRecords,
  setFinalData,
  clearAllEditableFields,
  UpdateTestRow,
  clearCompInitAction,
  emptyInputsTest,
  removeNewRows,
  UpdatetableCond,
  handleSaveToast,
  scrollToBottom,
  SetvalueClear,
  SetDisablePopup,
  setHandleSaveAll,
  handleLocalClear,
  handleInputClear,
  setInputtedData,
  setCloseExpand,
  handleSaveButtonClear,
  setPubStart,
  setselectedDistribution, setSelectedOrganization, setSelectedAccountName, setRepCodeSearchOptions, setAccountSearchOptions,
  setOrganizationSearchOptions, setHasMore, setSearchTerm, setCurrentPage,
  setDebouncedSearchTerm,
  setShouldClear,
  SetaddrowcancelData,
  setInputtedDataSt,
  setIsScroll,
  emptysegDetails,
  setNoSegId, clearSegDetails,
  setLocal,
  UpdateSeason,
  setRenderSeason,
  setResetSeason,
  setIsCleared,
  setClearCompState


} = Segslice.actions;
export default Segslice.reducer;